import PropTypes from "prop-types"
import React, { PureComponent } from "react"
import CoreLoading from "./loading"

// Checks whether all required packages are already registered, avoiding
// unnecessary loading work when packages were loaded by a previous render.
const areRequiredPackagesLoaded = (requiredPackages) => {
  const locallyStoredPackages = localStorage.getItem("APP_LOADED_PACKAGES") || ""

  let loadedPackages = locallyStoredPackages.split(",").filter(Boolean)
  const _requiredPackages = [...new Set(requiredPackages)]

  return loadedPackages.filter((pckg) => _requiredPackages.indexOf(pckg) > -1).length === _requiredPackages.length
}

class PackageLoader extends PureComponent {
  constructor(props) {
    super(props)

    this._isMounted = false
  }

  state = {
    ready: !Array.isArray(this.props.packages) || areRequiredPackagesLoaded(this.props.packages),
  }

  componentDidMount() {
    this._isMounted = true

    const { ready } = this.state
    const { packages } = this.props

    if (!ready) {
      this.lazyLoad(packages).then((cb) => {
        if (!this._isMounted) return
        if (typeof cb === "function") cb()
        this.setState({ ready: true })
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  lazyLoad = (packages = []) => {
    if (Array.isArray(packages) === true) {
      return this.props.loadPackages(packages)
    } else {
      console.log(packages)
      throw new Error("Packages argument needs to be an Array")
    }
  }

  render() {
    const { ready } = this.state
    const { children, showLoader } = this.props
    if (ready === false) return showLoader ? <CoreLoading centered /> : null
    if (typeof children === "object") return children
    return children(this.lazyLoad, this.props.components)
  }
}

PackageLoader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
}

export default PackageLoader
